import _orderBy from 'lodash/orderBy';

export const state = {
    sortCurrentChildPinFile: {
        loading: false,
        data: [],
    },
}


export const getters = {
}


export const mutations = {
    // SORTING PIN FILE
    sortByPinFile: (state, data) => {
        let selectedItems = data.items;
        let order = data.order;
        let key = data.key;

        state.sortCurrentChildPinFile.data = selectedItems;

        state.sortCurrentChildPinFile.data = _orderBy(selectedItems, key, order.toLowerCase());
    }
}


export const actions = {
}